import SovosButton from "mosaic-react/sovos-button";
import SovosDialog from "mosaic-react/sovos-dialog";
import SovosDialogActions from "mosaic-react/sovos-dialog-actions";
import SovosDialogContent from "mosaic-react/sovos-dialog-content";
import SovosDialogTitle from "mosaic-react/sovos-dialog-title";
import SovosMenuItem from "mosaic-react/sovos-menu-item";
import SovosSelect from "mosaic-react/sovos-select";

const LanguageDialog = (props) => {
    const {
        isOpen,
        setIsOpen,
        i18n,
        setUserLocale,
        userLocale,
        localesByAppTheme,
        setLocale,
        history
    } = props;
    return (
        <SovosDialog open={isOpen} onClose={() => { setIsOpen(false) }}>
            <SovosDialogTitle showCloseButton onClose={() => { setIsOpen(false) }}>{i18n`change language`}</SovosDialogTitle>
            <SovosDialogContent>
                <div>
                    <SovosSelect
                        onChange={(e) => setUserLocale(e.target.value)}
                        value={userLocale}
                        helperText={i18n`please select your language`}
                    >
                        {localesByAppTheme && localesByAppTheme.map((locale) => (
                            <SovosMenuItem value={locale.id} key={locale.id}>{i18n`${locale.name}`}</SovosMenuItem>
                        ))}
                    </SovosSelect>
                </div>
            </SovosDialogContent>
            <SovosDialogActions>
                <SovosButton variant="text" onClick={() => setIsOpen(false)}>
                    {i18n`cancel`}
                </SovosButton>
                <SovosButton onClick={() => {
                    setIsOpen(false);
                    setLocale(userLocale);
                    history.push(`/${userLocale}${history.location.pathname.substring(3)}`);
                }}>
                    {i18n`save`}
                </SovosButton>
            </SovosDialogActions>
        </SovosDialog>
    )
}

export default LanguageDialog;